import { render } from "./dialog-sentry.vue?vue&type=template&id=5b3eefcb"
import script from "./dialog-sentry.vue?vue&type=script&lang=js"
export * from "./dialog-sentry.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/toll-collector/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__